<template lang="pug">
  #home
    Header
    v-container(fluid)
      EditDialog(ref="editModal" v-bind:recordId="record['_id']")
      v-row
        v-col.list.px-2(:sm="12" :md="7")
          List
        v-col.pa-4.postalSection(:sm="12" :md="5")
          v-row.link-container
            a(@click="downloadImage()").link Descargar como imagen
            .link(v-if="userPermissions.updateReports || userPermissions.updateQuestionnaire")
              a.ml-3(@click="setEditForm") Editar información
  
          VictimPostal(v-if="!record.folio")
          //img(fluid v-else :src="record.postal.url")
          v-carousel#carousel(
            :cycle="false"
            hide-delimiters
            v-else
            active-class="active-img",
            v-model="slideIndex"
            )
            v-carousel-item(v-for="(item, i) in images" :key="i")
              img(:src="item + '?' + new Date().getTime()")
          v-row.statistics-button.pt-5
            v-btn.bold.secondary-color-button(to="/statistics") Estadísticas

</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import List from "@/components/List.vue";
import VictimPostal from "@/components/Postal/VictimPostal.vue";
import EditDialog from "./Modals/EditDialog.vue";
import * as d3 from "d3";
import * as _ from "lodash";

export default {
  name: "home",
  components: {
    Header,
    List,
    VictimPostal,
    EditDialog
  },
  data() {
    return {
      user: this.$store.state.user,
      images: [],
      slideIndex: 0
    };
  },
  computed: {
    record() {
      return this.$store.state.record;
    },
    userPermissions() {
      return this.$store.getters.user.permission;
    }
  },
  methods: {
    downloadImage() {
      if (
        this.record["_id"] === "" ||
        typeof this.record["_id"] === "undefined"
      ) {
        this.$store.commit("setShowNotification", {
          type: "error",
          title: "ERROR",
          text: "No has seleccionado un folio"
        });
      } else {
        let link = document.createElement("a");
        console.log(this.slideIndex, this.images);
        document.body.appendChild(link);
        link.href = this.images[this.slideIndex];
        link.click();
        document.body.removeChild(link);
      }
    },
    setEditForm() {
      if (
        this.record["_id"] === "" ||
        typeof this.record["_id"] === "undefined"
      ) {
        this.$store.commit("setShowNotification", {
          type: "error",
          title: "ERROR",
          text: "No has seleccionado un folio"
        });
      } else {
        this.$refs.editModal.pop();
      }
    }
  },
  watch: {
    record() {
      if (this.record.folio !== null) {
        this.images = [this.record.postal.url, this.record.miniPostal.url];
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.link-container {
  justify-content: space-evenly;
}
.link {
  color: #4a4a4a !important;
}
.secondary-color-button {
  box-shadow: none;
  height: 61px !important;
  border-radius: 8px;
  margin: 0px;
  letter-spacing: 0em;
  padding: 20px !important;
  background-color: #fab609 !important;
  font-size: 16px !important;
}
.carousel {
  margin: 15px 75px;
  width: 77%;
  box-shadow: none !important;
  & >>> .jumbotron__wrapper .jumbotron__image {
    height: 100% !important;
    min-height: 100%;
    width: 100%;
    min-width: 100%;
    object-fit: contain !important;
  }
  & >>> .btn.btn--icon {
    color: rgba(0, 0, 0, 0.26) !important;
  }
}
.statistics-button {
  margin: 0 auto !important;
  /*margin: 40px 10% !important;*/
}
</style>
